import React, { useEffect, useState } from "react"
import {
  validate_invitation_code,
  validate_vergabe_id,
} from "components/page-components/Ausschreibungsdienste/utils"
import { MagnifyingGlassIcon } from "components/page-components/Icons/small"

import adTenderTypeLandingpages from "data/ausschreibungsdienste/ad-tender-type-landingpages.json"

import { navigate } from "gatsby"
import { startCase } from "lodash"

export const Demosuche = ({
  withoutCTA = false,
  bundesland = "",
  exampleSearchQueries,
  fullwidth,
}) => {
  const all_placeholder_search_queries = adTenderTypeLandingpages
    .map(({ example_search_queries }) => example_search_queries)
    .sort()

  const [searchItem, setSearchItem] = useState("")
  const [exampleQuery, setExampleQuery] = useState("")

  const [is_valid_code, set_is_valid_code] = useState(false)

  useEffect(() => {
    setExampleQuery(
      exampleSearchQueries
        ? exampleSearchQueries[
            Math.floor(Math.random() * exampleSearchQueries?.length)
          ]
        : all_placeholder_search_queries[
            Math.floor(Math.random() * all_placeholder_search_queries?.length)
          ].join(", ")
    )
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    set_is_valid_code(
      validate_invitation_code(searchItem) || validate_vergabe_id(searchItem)
    )
  }, [searchItem])

  const updateSearchItem = (e) => setSearchItem(e?.target?.value?.trim())

  const clickToNavigate = () =>
    validate_invitation_code(searchItem)
      ? navigate(
          `/ausschreibungsdienste/teilnehmen/beschraenkte?einladung=${searchItem}`
        )
      : validate_vergabe_id(searchItem)
      ? navigate(`/ausschreibungsdienste/ausschreibungen/${searchItem}`)
      : navigate(
          `/ausschreibungsdienste#demosearch-box&q=${searchItem}${
            bundesland
              ? `&bundesland=${startCase(bundesland).split(" ").join("-")}`
              : ""
          }`
        )
  const handleEnter = (e) => {
    const { keyCode } = e
    if (keyCode === 13) {
      clickToNavigate()
    }
  }
  return (
    <div className="mt-4">
      {!withoutCTA ? (
        <React.Fragment>
          <p className="subtitle is-6 has-text-mitternachtsblau has-text-centered">
            Sie suchen Aufträge für Ihre Firma?
          </p>
          <p className="title is-3 mt-2 mb-6 has-text-mitternachtsblau has-text-centered">
            Finden Sie jetzt Aufträge in ganz Deutschland.
          </p>
        </React.Fragment>
      ) : null}
      <div className="columns is-centered is-vcentered is-gapless">
        <div className={`column${!!fullwidth ? "" : " is-5-desktop"}`}>
          <div className="control has-icons-left" style={{ height: 48 }}>
            <input
              className="input"
              type="demosuche"
              aria-label="demosuche"
              placeholder={`Suchbegriff (z.B. ${exampleQuery})`}
              onChange={updateSearchItem}
              onKeyDown={handleEnter}
            />
            <span className="icon is-left">
              <MagnifyingGlassIcon {...{ color: "#b3cbd4" }} />
            </span>
          </div>
        </div>
        <div className="column is-narrow has-text-centered">
          <button
            onClick={clickToNavigate}
            className="button is-sonnengelb has-text-weight-bold is-fullwidth"
          >
            {is_valid_code ? "Zur Vergabe" : "Aufträge finden"}
          </button>
        </div>
      </div>
    </div>
  )
}
